/* Lycavia: Galerie zum Wischen und Kaufleiste fürs Handy. Läuft neben lycavia.js, ohne globale Namen. */
(() => {
  "use strict";
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const handy = window.matchMedia("(max-width: 900px)");
  const ruhig = window.matchMedia("(prefers-reduced-motion: reduce)");
  const art = () => (ruhig.matches ? "auto" : "smooth");

  // 1 Galerie: Punkte erzeugen, aktiven Punkt beim Wischen setzen, beim Packungswechsel zum ersten Bild
  $$("[data-galerie]").forEach((galerie) => {
    const bereich = galerie.closest("[data-kaufbereich]") || galerie.parentElement;
    const punkte = $("[data-galerie-punkte]", bereich);
    const bilder = $$(":scope > .kauf__hauptbild, :scope > .kauf__bilder > *", galerie);
    const zu = (i, verhalten) => {
      const ziel = bilder[i];
      if (ziel) galerie.scrollTo({ left: ziel.offsetLeft - bilder[0].offsetLeft, behavior: verhalten });
    };

    $$("[data-packungen]", bereich).forEach((gruppe) => gruppe.addEventListener("change", () => zu(0, art())));
    if (!punkte || bilder.length < 2) return;

    const knoepfe = bilder.map((_, i) => {
      const k = document.createElement("button");
      k.type = "button";
      k.setAttribute("aria-label", `Bild ${i + 1} von ${bilder.length}`);
      k.setAttribute("aria-current", String(i === 0));
      k.addEventListener("click", () => zu(i, art()));
      punkte.append(k);
      return k;
    });
    punkte.hidden = false;

    let aktiv = 0;
    let wartet = false;
    galerie.addEventListener("scroll", () => {
      if (wartet) return;
      wartet = true;
      requestAnimationFrame(() => {
        wartet = false;
        const breite = galerie.clientWidth || 1;
        const i = Math.min(bilder.length - 1, Math.max(0, Math.round(galerie.scrollLeft / breite)));
        if (i === aktiv) return;
        knoepfe[aktiv].setAttribute("aria-current", "false");
        knoepfe[i].setAttribute("aria-current", "true");
        aktiv = i;
      });
    }, { passive: true });
  });

  // 2 Kaufleiste: sichtbar, sobald der Hauptknopf über dem Bildschirm liegt; folgt der gewählten Packung
  $$("[data-kaufleiste]").forEach((leiste) => {
    const bereich = leiste.closest("[data-kaufbereich]");
    const haupt = bereich && $(".kauf__info > [data-in-den-korb]", bereich);
    const knopf = $("[data-in-den-korb]", leiste);
    if (!haupt || !knopf) return;

    const packung = $("[data-kaufleiste-packung]", leiste);
    const preis = $("[data-kaufleiste-preis]", leiste);
    const grund = $("[data-kaufleiste-grundpreis]", leiste);
    const tag = $("[data-kaufleiste-tagespreis]", leiste);
    const tagTrenner = $("[data-kaufleiste-tagespreis-trenner]", leiste);
    document.body.classList.add("hat-kaufleiste");

    let ueberBildschirm = false;
    const zeigen = () => {
      const an = ueberBildschirm && handy.matches;
      if (!an && leiste.contains(document.activeElement)) haupt.focus({ preventScroll: true });
      leiste.classList.toggle("ist-sichtbar", an);
      leiste.setAttribute("aria-hidden", String(!an));
      knopf.tabIndex = an ? 0 : -1;
    };
    // Lage direkt messen statt IntersectionObserver: Sprünge (z. B. Tipp auf die Statusleiste) lösen dort keinen Wechsel aus.
    let wartet = false;
    const pruefen = () => {
      wartet = false;
      const jetzt = haupt.getBoundingClientRect().bottom < 0;
      if (jetzt === ueberBildschirm) return;
      ueberBildschirm = jetzt;
      zeigen();
    };
    const planen = () => { if (!wartet) { wartet = true; requestAnimationFrame(pruefen); } };
    addEventListener("scroll", planen, { passive: true });
    addEventListener("resize", planen);
    handy.addEventListener("change", zeigen);
    pruefen();

    const spiegeln = () => {
      knopf.disabled = haupt.disabled;
      knopf.textContent = haupt.textContent.trim();
    };
    new MutationObserver(spiegeln).observe(haupt, { attributes: true, attributeFilter: ["disabled"] });
    spiegeln();

    const gruppe = $("[data-packungen]", bereich);
    if (!gruppe) return;
    const packungZeigen = () => {
      const wahl = $("input[type='radio'][name='id']:checked", gruppe);
      if (!wahl) return;
      const name = $("b", wahl.closest("label") || gruppe);
      if (packung && name) packung.textContent = name.textContent.trim();
      if (preis && wahl.dataset.preis !== undefined) preis.textContent = wahl.dataset.preis;
      if (grund && wahl.dataset.grundpreis !== undefined) grund.textContent = wahl.dataset.grundpreis;
      if (tag && wahl.dataset.tagespreis !== undefined) {
        const text = wahl.dataset.tagespreis;
        tag.textContent = text;
        tag.hidden = !text;
        if (tagTrenner) tagTrenner.hidden = !text;
      }
    };
    gruppe.addEventListener("change", packungZeigen);
    packungZeigen(); // Browser kann beim Zurückgehen eine andere Auswahl wiederherstellen
  });
})();
